export default __webpack_public_path__ + "static/media/ThinkContractPERT.b1b4e28680ea9ff9fda7aed89d557854.webp";